import React from 'react';
import { 
  Grid, 
  Card, 
  CardMedia, 
  CardContent, 
  Typography, 
  Box,
  Chip,
  Paper
} from '@mui/material';
import { FaLeaf, FaWheatAlt } from 'react-icons/fa6';

// Sample restaurant menu items
const menuItems = [
  {
    name: "The Director's Cut Burger",
    description: "Premium Wagyu beef, aged cheddar, arugula, truffle aioli, caramelized onions on a brioche bun. Served with rosemary fries.",
    price: "$18.95",
    image: "/images/food/burger.jpg",
    category: "Main Courses",
    tags: [],
    featured: true
  },
  {
    name: "Sci-Fi Sushi Platter",
    description: "Assortment of chef's special rolls including Volcano Roll, Galaxy Roll, and Nebula Nigiri. Served with wasabi and ginger.",
    price: "$22.95",
    image: "/images/food/sushi.jpg",
    category: "Main Courses",
    tags: [],
    featured: true
  },
  {
    name: "Blockbuster Loaded Nachos",
    description: "Tortilla chips loaded with melted cheese, jalapeños, black beans, pico de gallo, guacamole, and sour cream.",
    price: "$14.95",
    image: "/images/food/nachos.jpg",
    category: "Appetizers",
    tags: ["vegetarian"],
    featured: true
  },
  {
    name: "Mediterranean Flatbread",
    description: "Artisanal flatbread topped with sun-dried tomatoes, olives, feta cheese, and fresh basil.",
    price: "$15.95",
    image: "/images/food/flatbread.jpg",
    category: "Appetizers",
    tags: ["vegetarian"],
    featured: true
  },
  {
    name: "Movie Marathon Sliders",
    description: "Trio of gourmet mini burgers with different toppings. Perfect for sharing!",
    price: "$16.95",
    image: "/images/food/sliders.jpg",
    category: "Appetizers",
    tags: [],
    featured: true
  },
  {
    name: "Academy Award Chocolate Lava Cake",
    description: "Warm chocolate cake with a molten center, served with vanilla ice cream and berry compote.",
    price: "$9.95",
    image: "/images/food/chocolate-cake.jpg",
    category: "Desserts",
    tags: ["vegetarian"],
    featured: true
  },
];

const RestaurantMenu = () => {
  return (
    <Box>
      <Grid container spacing={3}>
        {menuItems.map((item, index) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            key={index}
            sx={{
              animation: `fadeIn ${0.3 + index * 0.1}s ease-out`,
              '@keyframes fadeIn': {
                '0%': { opacity: 0, transform: 'translateY(20px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' }
              }
            }}
          >
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                borderRadius: 3,
                overflow: 'hidden',
                boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 25px rgba(0,0,0,0.18)',
                  '& .menu-img': {
                    transform: 'scale(1.05)'
                  }
                }
              }}
            >
              <Box sx={{ position: 'relative', overflow: 'hidden' }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={item.image}
                  alt={item.name}
                  className="menu-img"
                  sx={{ 
                    transition: 'transform 0.5s ease',
                  }}
                />
                <Box 
                  sx={{ 
                    position: 'absolute',
                    top: 12,
                    left: 12,
                    zIndex: 2
                  }}
                >
                  <Chip 
                    label={item.category}
                    size="small"
                    sx={{ 
                      bgcolor: 'primary.dark',
                      color: 'white',
                      fontWeight: 'bold',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                  />
                </Box>
                {item.tags.includes('vegetarian') && (
                  <Box 
                    sx={{ 
                      position: 'absolute',
                      top: 12,
                      right: 12,
                      zIndex: 2
                    }}
                  >
                    <Chip 
                      icon={<FaLeaf size={12} />}
                      label="Vegetarian"
                      size="small"
                      sx={{ 
                        bgcolor: 'success.main',
                        color: 'white',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}
                    />
                  </Box>
                )}
              </Box>
              <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                  <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
                    {item.name}
                  </Typography>
                  <Paper 
                    elevation={2}
                    sx={{ 
                      px: 1.5, 
                      py: 0.5, 
                      bgcolor: 'secondary.main', 
                      color: 'white',
                      fontWeight: 'bold',
                      borderRadius: 2,
                    }}
                  >
                    {item.price}
                  </Paper>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RestaurantMenu; 